import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AppointmentButton.scss';
import * as types from 'constants/ActionTypes.js';
import cn from 'classnames';
import { setPopUp } from 'actions/environment';
import { useDispatch } from 'react-redux';
import AppointmentDialog from '../AppointmentDialog/AppointmentDialog';
import { loadCalendar } from '../../../actions/appointment';
import { ButtonSpinner } from '../../common/ButtonSpinner/ButtonSpinner';
import { OFFLINE_APPOINTMENT_TYPE } from '../../../constants';
import { gaEvent, trackGA } from 'services/ga';

const AppointmentButton = ({ buildingId, profile, title, objectType }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    trackGA(
      gaEvent.buildingRightMenuButtonsClick({
        eventLabel: 'zapisatsya_na_pokaz',
        eventContent: title,
        productType: objectType,
        productName: title,
        productID: buildingId,
        user_id: profile.id,
      })
    );

    setIsLoading(true);
    try {
      const dataOffline = await dispatch(
        loadCalendar({
          building_id: buildingId,
          type: OFFLINE_APPOINTMENT_TYPE,
        })
      );

      if (dataOffline.data) {
        dispatch(
          setPopUp(
            <AppointmentDialog
              data={dataOffline}
              buildingId={buildingId}
              profile={profile}
              buildingName={title}
              objectType={objectType}
            />,
            {
              closeStyleName: 'Default',
              contentStyleName: 'Default',
              closeIcon: 'default',
              lockScroll: false,
            }
          )
        );
      } else {
        dispatch({ type: types.LOAD_CALENDAR_ERROR });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button className={cn(styles.ActionBtn, styles.AppointmentButton)} onClick={handleClick}>
      {isLoading ? <ButtonSpinner /> : t('components.appointment.appointmentButton.button')}
    </button>
  );
};

export default AppointmentButton;



// WEBPACK FOOTER //
// ./src/components/Appointment/AppointmentButton/AppointmentButton.jsx